import { inject, Injectable } from '@angular/core';
import { LoaderService } from 'src/app/core';
import { AlertDialogService, ConfirmDialogService, PrinterErrorFiscalDialogService } from 'src/app/dialogs';

@Injectable()
export class PrinterOperationService {

  private loaderService = inject(LoaderService);
  private confirmDialogService = inject(ConfirmDialogService);
  private alertDialogService = inject(AlertDialogService);
  private printerErrorFiscal = inject(PrinterErrorFiscalDialogService);

  async execute<T>(config: { 
    confirmMessage?: string, 
    operationFn: () => Promise<T>, 
    successMessage?: string,
    printerId: string 
  }): Promise<T | undefined> {

    if (config.confirmMessage) {
      const proceed = await this.confirmDialogService.openDialog({
        data: { 
          messageLabel: config.confirmMessage
        }
      });
      if (!proceed) return undefined;
    }

    this.loaderService.show();
    try {
      const result = await config.operationFn();
      if (config.successMessage) {
        this.alertDialogService.openDialog({
          data: {
            messageLabel: config.successMessage
          }
        });
      }
      return result;
    } catch (error) {
      this.printerErrorFiscal.show(error, { printerId: config.printerId });
      return undefined;
    } finally {
      this.loaderService.hide();
    }
  }

  triggerDownload(blob: Blob, fileName: string) {
    const url = window.URL.createObjectURL(blob);
    
    const link = document.createElement('a');
    link.href = url;
    if(fileName) link.download = fileName;
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    window.URL.revokeObjectURL(url);
  }
}
